import { AppsFlyer } from '../plugins/apps_flyer_plugin.js';
import { analytics } from './index.js';
import { AnalyticsPropertyKey } from './analytics_types.js';

type CampaignPlayer = {
  campaign_key?: unknown;
};

export function setCampaignAnalyticsFromPlayer(player: CampaignPlayer): void
{
  if (!Object.prototype.hasOwnProperty.call(player, 'campaign_key')) return;

  const raw_campaign = player.campaign_key;
  const campaign = typeof raw_campaign === 'string' && raw_campaign.trim().length > 0
    ? raw_campaign.trim()
    : 'base';

  analytics.setCommonProperties({
    [AnalyticsPropertyKey.CAMPAIGN]: campaign,
  });
  AppsFlyer.setCommonEventValues({ campaign });
}
